module.exports = __webpack_public_path__ + "static/media/team-todd.47335d81.jpg";